(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/reduce-free-container.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/reduce-free-container.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.views.ReduceFreeContainer = Backbone.Marionette.View.extend({
    ui: {
      input: '.js-input',
      text: '.reduce-free-container p',
      errorMessage: '.bet-amounts-invalid',
      readMoreLink: '.js-reduce-free-read-more'
    },

    events: {
      'input @ui.input': 'handleInputChange',
      'focus @ui.input': 'handleInputFocus',
      'blur @ui.input': 'handleInputBlur',
      'keydown @ui.input': 'handleInputKeyDown',
      'click @ui.readMoreLink': 'handleReadMoreClick'
    },

    template: function(data) {
      return svs.tipset.templates.reduce_free_container(data);
    },

    templateContext: function() {
      return {
        rows: svs.tipset.models.reduceFreeContainer.get('rows'),
        minRows: svs.tipset.constants.MIN_ROWS_INPUT_REDUCE_FREE,
        maxRows: svs.tipset.constants.MAX_ROWS_INPUT_REDUCE_FREE
      };
    },

    initialize: function() {
      var self = this;
      this.canValidate = false;
      this.listenTo(
        svs.tipset.models.reduceFreeContainer,
        'updateRows',
        function() {
          var value = svs.tipset.models.reduceFreeContainer.get('rows');

          if (
            value >= svs.tipset.constants.MIN_ROWS_INPUT_REDUCE_FREE &&
            value <= svs.tipset.constants.MAX_ROWS_INPUT_REDUCE_FREE
          ) {
            self.ui.input.val(value);
          }
        }
      );

      this.handleSpelguideScroll = this.handleSpelguideScroll.bind(this);

      setTimeout(function() {
        svs.tipset.productBase.on('tabChanged', self.handleSpelguideScroll);
      });
    },

    onDestroy: function() {
      svs.tipset.productBase.off('tabChanged', this.handleSpelguideScroll);
    },

    handleReadMoreClick: function(e) {
      e.preventDefault();
      var self = this;

      if (
        location.search.indexOf(
          svs.tipset.data.config.freeReduceReadMore.tab
        ) === -1
      ) {
        var betslipOpen = svs.tipset.views.betslip.betslipIsOpen;

        svs.obj.router.navigate(
          '?flik=' + svs.tipset.data.config.freeReduceReadMore.tab,
          { trigger: true }
        );

        setTimeout(function() {
          self.handleSpelguideScroll(betslipOpen);
        }, 0);
      } else {
        self.handleSpelguideScroll(false);
      }
    },

    handleSpelguideScroll: function(betslipOpen) {
      if (
        location.search.indexOf(
          svs.tipset.data.config.freeReduceReadMore.tab
        ) === -1
      ) {
        return;
      }

      var $reduceFreeTitle = $(
          ":header:contains('" +
            svs.tipset.data.config.freeReduceReadMore.header +
            "')"
        ),
        scrollPosition = $reduceFreeTitle.offset().top,
        $swiperContainer = $('.slider-slide-active .js-swiper-container'),
        swiperContainerScrollPos = $swiperContainer.scrollTop(),
        scrollAmount = scrollPosition + swiperContainerScrollPos,
        tabsMenuHeaderHeight = $('.js-product-base-tabs-nav').outerHeight(),
        menuHeaderHeight = $('.header').outerHeight();
      $swiperContainer.scrollTop(
        scrollAmount - tabsMenuHeaderHeight - menuHeaderHeight
      );

      if (betslipOpen) {
        svs.tipset.views.betslip.openBetslip();
      }
    },

    handleInputFocus: function() {
      if (!svs.core.detect.formfactor.mobile()) {
        return;
      }

      window.scrollTo(0, 0);
      document.body.scrollTop = 0;

      var scrollPosition = this.ui.text.offset().top,
        $swiperContainer = $('.slider-slide-active .js-swiper-container'),
        swiperContainerScrollPos = $swiperContainer.scrollTop(),
        scrollAmount = scrollPosition + swiperContainerScrollPos,
        tabsMenuHeaderHeight = $('.js-product-base-tabs-nav').outerHeight(),
        menuHeaderHeight = $('.header').outerHeight();
      $swiperContainer.scrollTop(
        scrollAmount - tabsMenuHeaderHeight - menuHeaderHeight
      );
    },

    handleInputBlur: function() {
      if (this.canValidate === false) {
        this.canValidate = true;
        this.validate();
      }
    },

    handleInputKeyDown: function(e) {
      if (this.canValidate === false && e.keyCode === 13) {
        this.canValidate = true;
        this.validate();
      }
    },

    validate: function() {
      if (this.canValidate !== true) {
        svs.components.formValidation.hideErrorMessage('amount');
        return;
      }

      var value = parseInt(this.ui.input.val(), 10);

      if (
        value !== '' &&
        value < svs.tipset.constants.MIN_ROWS_INPUT_REDUCE_FREE
      ) {
        svs.components.formValidation.showErrorMessage('amount', {
          message:
            'Välj ' +
            svs.tipset.constants.MIN_ROWS_INPUT_REDUCE_FREE +
            ' - ' +
            svs.tipset.constants.MAX_ROWS_INPUT_REDUCE_FREE +
            ' rader'
        });
        this.ui.errorMessage.removeClass('hide');
        return;
      }

      svs.components.formValidation.hideErrorMessage('amount');
    },

    clampInput: function() {
      var value = this.ui.input.val();

      if (value) {
        value = parseInt(value, 10);

        if (value > svs.tipset.constants.MAX_ROWS_INPUT_REDUCE_FREE) {
          value = svs.tipset.constants.MAX_ROWS_INPUT_REDUCE_FREE;
        }
      }

      this.ui.input.val(value);
    },

    trimNonNumbers: function() {
      var value = this.ui.input.val().trim();
      value = value.replace(/\D/g, '');
      this.ui.input.val(value);
    },

    handleInputChange: function(e) {
      if (document.activeElement !== e.currentTarget) {
        return;
      }

      this.trimNonNumbers();
      this.clampInput();
      this.validate();

      var value = this.ui.input.val();

      value = parseInt(value, 10);

      if (!value) {
        value = 0;
      }

      svs.tipset.models.reduceFreeContainer.set({
        rows: value
      });

      svs.tipset.objects.localstorageHandler.saveDataToLocalStorage();
    }
  });
})(Backbone, _, svs);

 })(window);